import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "./Baseurl";
import Swal from "sweetalert2"; 


const ScheduleMeeting = ({ eventUniqueId, eventtime, exhibitors }) => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);
  const [availableDates, setAvailableDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [timeSlots, setTimeSlots] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [existingSchedule, setExistingSchedule] = useState(null);

  useEffect(() => {
    const storedUserId = localStorage.getItem("visitor_id");
    setUserId(storedUserId);
  }, []);

  useEffect(() => {
    if (eventtime && eventtime.length > 0) {
      const dates = eventtime.map((e) => e.selected_date);
      setAvailableDates(dates);
    }
  }, [eventtime]);

  useEffect(() => {
    if (userId && eventUniqueId) {
      checkExistingSchedule();
    }
  }, [userId, eventUniqueId]);

  const checkExistingSchedule = async () => {
    try {
      const response = await axios.get(`${BASE_URL}getScheduleSlots/${userId}/${eventUniqueId}`);
      
      if (response.data.success && response.data.data.length > 0) {
        // Find an existing slot where user_id, event_unique_id, and exhibitor_id match
        const existingSlot = response.data.data.find(
          (slot) => slot.user_id === userId && slot.event_unique_id === eventUniqueId && slot.exhibitor_id === exhibitors
        );
  
        if (existingSlot) {
          setExistingSchedule(existingSlot);
          setSelectedDate(existingSlot.selected_date);
          setSelectedTime(existingSlot.selected_slot);
        }
      }
    } catch (error) {
      console.error("Error fetching schedule slots:", error);
    }
  };
  

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setSelectedTime(null);

    const event = eventtime.find((e) => e.selected_date === date);
    if (event) {
      generateTimeSlots(event.start_time, event.end_time, event.timezone);
    } else {
      setTimeSlots([]);
    }
  };

  const generateTimeSlots = (startTime, endTime, timezone) => {
    let slots = [];
    let start = new Date(`1970-01-01T${startTime}${timezone}`);
    let end = new Date(`1970-01-01T${endTime}${timezone}`);

    while (start < end) {
      let next = new Date(start.getTime() + 30 * 60000);
      slots.push(`${start.toTimeString().slice(0, 5)} - ${next.toTimeString().slice(0, 5)}`);
      start = next;
    }

    setTimeSlots(slots);
  };

   

  const handleConfirmSlot = async () => {
    if (!selectedDate || !selectedTime) return;

    setIsSubmitting(true);
    const data = {
        user_id: userId,
        event_unique_id: eventUniqueId,
        selected_date: selectedDate,
        selected_slot: selectedTime,
        exhibitor_id: exhibitors, // Sending exhibitor ID
    };

    console.log("data", data);

    try {
        const response = await axios.post(`${BASE_URL}saveScheduleSlot`, data);
        console.log("Meeting scheduled:", response.data);

        // Success Alert with SweetAlert2
        Swal.fire({
            title: "Success!",
            text: "Meeting Scheduled Successfully!",
            icon: "success",
            confirmButtonText: "OK",
        }).then(() => {
            document.getElementById("closeModalBtn").click(); // Close modal
            checkExistingSchedule(); // Refresh the schedule status
        });

    } catch (error) {
        console.error("Error scheduling meeting:", error);

        // Check if response contains the delegate registration message
        if (error.response && error.response.data && error.response.data.message === "Please register as a Exhibitor to schedule a slot.") {
            Swal.fire({
                title: "Registration Required!",
                text: "Please register as a Exhibitor to schedule a slot.",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else {
            Swal.fire({
                title: "Error!",
                text: "Failed to schedule meeting. Try again.",
                icon: "error",
                confirmButtonText: "OK",
            });
        }

    } finally {
        setIsSubmitting(false);
    }
};



  return (
    <div>
      <div>
        <span className="text-primary" data-bs-toggle="modal" data-bs-target="#scheduleModal">
          Schedule a Slot
        </span>
      </div>

      <div className="modal fade" id="scheduleModal" tabIndex="-1" aria-labelledby="scheduleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content p-3">
            <div className="modal-header">
              <h5 className="modal-title" id="scheduleModalLabel">Select Date and Time Slot</h5>
              <button type="button" className="btn-close" id="closeModalBtn" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {existingSchedule ? (
                <div className="alert alert-info">
                  <strong>Scheduled Slot:</strong>
                  <p><strong>Date:</strong> {existingSchedule.selected_date.split("T")[0]}</p>
                  <p><strong>Time:</strong> {existingSchedule.selected_slot}</p>
                </div>
              ) : (
                <>
                  <h6>Select Date</h6>
                  <div className="d-flex flex-wrap gap-2">
                    {availableDates.map((date) => (
                      <span
                        key={date}
                        className={`badge rounded-pill p-2 ${selectedDate === date ? "bg-primary text-white" : "bg-light text-dark"}`}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDateChange(date)}
                      >
                        {date}
                      </span>
                    ))}
                  </div>

                  {timeSlots.length > 0 && (
                    <>
                      <h6 className="mt-3">Select Time Slot</h6>
                      <div className="d-flex flex-wrap gap-2">
                        {timeSlots.map((slot, index) => (
                          <span
                            key={index}
                            className={`badge rounded-pill p-2 ${selectedTime === slot ? "bg-success text-white" : "bg-light text-dark"}`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setSelectedTime(slot)}
                          >
                            {slot}
                          </span>
                        ))}
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
            <div className="modal-footer">
              {!existingSchedule && (
                <button
                  className="btn btn-success"
                  onClick={handleConfirmSlot}
                  disabled={!selectedDate || !selectedTime || isSubmitting}
                >
                  {isSubmitting ? "Processing..." : "Confirm Slot"}
                </button>
              )}
              <button className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleMeeting;
